export const getFormattedDate = (date: Date, regionalLocale?: string) => {
  const dateConfig: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    month: '2-digit',
    day: '2-digit',
  };

  return date.toLocaleDateString(regionalLocale, dateConfig);
};
export const getFormattedTime = (date: Date, regionalLocale?: string) => {
  const timeConfig: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h24',
  };

  return date.toLocaleTimeString(regionalLocale, timeConfig);
};

export const getDueBy = (
  from?: Date,
  to?: Date,
  regionalLocale?: string,
): string => {
  const isRange = from && to && from.getTime() !== to.getTime();

  if (isRange) {
    return `${getFormattedDate(from, regionalLocale)}, ${getFormattedTime(
      from,
      regionalLocale,
    )} - ${getFormattedTime(to, regionalLocale)}`;
  }

  return `${getFormattedDate(
    (from ?? to)!,
    regionalLocale,
  )}, ${getFormattedTime((from ?? to)!, regionalLocale)}`;
};
